module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"clappr","commonjs":"clappr","commonjs2":"clappr","root":"Clappr"}
// module id = 20
// module chunks = 0